const ITEMS = [
  "Make Every Moment Yours",
  "Personalised Gifts",
  "Weddings & Events",
  "Custom Creations",
  "Corporate Gifting",
  "Coming Soon",
];

const Diamond = () => (
  <svg viewBox="0 0 12 12" className="w-2.5 h-2.5 shrink-0" fill="#D4AF37" aria-hidden="true">
    <path d="M6 0l6 6-6 6-6-6z" />
  </svg>
);

const Row = () => (
  <div className="flex shrink-0">
    {ITEMS.map((t, i) => (
      <span
        key={i}
        className="flex items-center gap-10 pr-10 font-serif italic text-lg md:text-xl text-[#C57B89] whitespace-nowrap"
      >
        {t}
        <Diamond />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      className="overflow-hidden border-y border-[#E8E1D9] bg-[#F9F6F0] py-5"
      data-testid="tagline-marquee"
    >
      <div className="flex w-max animate-marquee">
        <Row />
        <Row />
      </div>
    </div>
  );
}
